/* Fetchy cart drawer + header cart count. Works with sections/fetchy-cart-drawer.liquid */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'fetchy-cart-drawer';
  var drawer = document.querySelector('[data-fx-drawer]');
  var guardMsg = false;
  var stripping = false;

  function setCount(n) {
    document.querySelectorAll('[data-fx-count]').forEach(function (el) {
      el.textContent = n; el.hidden = !(n > 0);
      var a = el.closest('a'); if (a) a.setAttribute('aria-label', 'Cart, ' + n + ' item' + (n === 1 ? '' : 's'));
    });
  }
  function refreshCount() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; }).catch(function () {});
  }
  window.FetchyCart = { setCount: setCount, refreshCount: refreshCount };

  window.addEventListener('pageshow', function () { refreshCount(); if (drawer && drawer.classList.contains('is-open')) render(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCount(); });

  if (!drawer) return;
  var panel = drawer.querySelector('.fx-drawer__panel');

  function apply(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-fx-content]');
    var cur = drawer.querySelector('[data-fx-content]');
    if (fresh && cur) cur.replaceWith(fresh);
    var c = drawer.querySelector('[data-fx-content]');
    if (c) setCount(parseInt(c.getAttribute('data-count'), 10) || 0);
    if (guardMsg) { var m = drawer.querySelector('[data-fx-guard-msg]'); if (m) m.hidden = false; }
    guard();
    stripIncludedExtra();
  }
  function render() {
    return fetch(ROOT + '?sections=' + SECTION, { cache: 'no-store' }).then(function (r) { return r.json(); })
      .then(function (j) { apply(j[SECTION]); });
  }
  function busy(on) { var c = drawer.querySelector('[data-fx-content]'); if (c) c.classList.toggle('is-busy', on); }
  function guard() {
    var g = drawer.querySelector('[data-fx-guard]');
    if (!g) return;
    var updates = {};
    g.querySelectorAll('[data-fx-addon-key]').forEach(function (n) { updates[n.getAttribute('data-fx-addon-key')] = 0; });
    if (!Object.keys(updates).length) return;
    guardMsg = true; g.remove(); busy(true);
    fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: SECTION }) })
      .then(function (r) { return r.json(); }).then(function (j) { apply(j.sections && j.sections[SECTION]); })
      .catch(function () { render(); });
  }
  function stripIncludedExtra() {
    if (stripping) return;
    var s = drawer.querySelector('[data-fx-strip-extra]');
    if (!s) return;
    var key = s.getAttribute('data-key');
    if (!key) return;
    stripping = true; s.remove(); busy(true);
    fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0, sections: SECTION }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { stripping = false; if (j.sections) apply(j.sections[SECTION]); else render(); })
      .catch(function () { stripping = false; render(); });
  }
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fx-lock');
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    guard();
    stripIncludedExtra();
  }
  function close() {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fx-lock'); guardMsg = false;
    var m = drawer.querySelector('[data-fx-guard-msg]'); if (m && !drawer.querySelector('[data-fx-guard]') && drawer.querySelector('[data-fx-content]').getAttribute('data-blocked') !== 'true') m.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function change(key, qty) {
    busy(true);
    return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTION }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j.sections) apply(j.sections[SECTION]); else render(); })
      .catch(function () { render(); });
  }
  function toggleExtra(input) {
    if (input.disabled) return;
    var on = input.checked;
    var key = input.getAttribute('data-key');
    var vid = Number(input.getAttribute('data-variant'));
    var kind = input.getAttribute('data-kind') || 'extra';
    busy(true);
    if (on) {
      if (!vid) { input.checked = false; busy(false); return; }
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _ck_addon: kind } }], sections: SECTION })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add'); return j; }); })
        .then(function (j) { if (j.sections) apply(j.sections[SECTION]); else render(); })
        .catch(function () { input.checked = false; render(); });
    } else {
      if (!key) { render(); return; }
      change(key, 0);
    }
  }
  window.FetchyDrawer = {
    open: open, close: close, render: render,
    afterAdd: function () { return render().then(open); }
  };

  drawer.addEventListener('click', function (e) {
    var q = e.target.closest('[data-fx-qty]');
    if (q) { e.preventDefault(); var li = q.closest('[data-key]'); if (li) change(li.getAttribute('data-key'), Math.max(0, parseInt(q.getAttribute('data-fx-qty'), 10) || 0)); return; }
    var x = e.target.closest('[data-fx-close]');
    if (x) { if (x.tagName === 'A' && location.pathname === new URL(x.href, location.href).pathname) { e.preventDefault(); } else if (x.tagName === 'A') { return; } close(); }
  });
  drawer.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-fx-extra]');
    if (inp) toggleExtra(inp);
  });
  drawer.addEventListener('submit', function (e) {
    if (drawer.querySelector('[data-fx-content]').getAttribute('data-blocked') === 'true') { e.preventDefault(); guardMsg = true; guard(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-fx-open]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (/\/cart\/?$/.test(location.pathname)) return;
    e.preventDefault(); render().then(open);
  });
})();

/* Cart page extras (same tick boxes as the drawer). Reloads the page after a change. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function stripPageExtra() {
    var s = document.querySelector('[data-page-cart] ~ [data-fx-strip-extra], [data-fx-strip-extra]');
    // Prefer the strip marker next to page extras
    var markers = document.querySelectorAll('[data-fx-strip-extra]');
    if (!markers.length) return;
    var key = markers[0].getAttribute('data-key');
    if (!key) return;
    markers.forEach(function (m) { m.remove(); });
    fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { location.reload(); }).catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-fx-extra]');
    if (!inp) return;
    // Drawer handles its own extras via the drawer listener; skip if inside drawer
    if (inp.closest('[data-fx-drawer]')) return;
    if (inp.disabled) return;
    var on = inp.checked;
    var key = inp.getAttribute('data-key');
    var vid = Number(inp.getAttribute('data-variant'));
    var kind = inp.getAttribute('data-kind') || 'extra';
    inp.disabled = true;
    if (on) {
      if (!vid) { inp.checked = false; inp.disabled = false; return; }
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _ck_addon: kind } }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add'); return j; }); })
        .then(function () { location.reload(); })
        .catch(function () { inp.checked = false; inp.disabled = false; });
    } else {
      if (!key) { inp.disabled = false; return; }
      fetch(ROOT + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { location.reload(); })
        .catch(function () { inp.checked = true; inp.disabled = false; });
    }
  });
  if (document.querySelector('[data-page-cart]')) stripPageExtra();
})();
